const IMAGES = {
  ChannelitixLogo: require("./channelitixlogo.svg").default,
  MenuIcon: require("./Ellipse.svg").default,
  HighlightedMenuIcon: require("./Ellipse1.svg").default,
  UploadImage: require("./UploadImage.svg").default,
  ChannelitixIcon: require("./channelitix.svg").default,
  ChannelPay: require("./channelpay.svg").default,
  ChannelPaisa: require("./channelPaisa.svg").default,
  LocationIcon: require("./location_icon.svg").default,
  SmartFill: require("./smartFill.svg").default
};

export default IMAGES;
